// extracted by mini-css-extract-plugin
module.exports = {"spec_title":"table_spec_title__T_Eyb","spec_value":"table_spec_value__BROHc"};